// extracted by mini-css-extract-plugin
export default {"gaurdian_header":"NominationDetail_gaurdian_header__QEbGM","addNominee":"NominationDetail_addNominee__bwtX4","file_instruction":"NominationDetail_file_instruction__Sorcb"};